(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy4tech-cart-progress"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('b4t-cart-progress'))customElements.define('b4t-cart-progress',class extends HTMLElement{
connectedCallback(){this.update=(event)=>{const cart=event.detail?.cart;if(cart&&Number.isFinite(cart.total_price))this.paint(cart.total_price);};document.addEventListener('cart:updated',this.update);this.paint(Number(this.dataset.total));}
disconnectedCallback(){document.removeEventListener('cart:updated',this.update);cancelAnimationFrame(this.frame);}
paint(total){const left=Math.max(0,300000-total);const amount='Rs. '+new Intl.NumberFormat('en-PK',{maximumFractionDigits:0}).format(left/100);this.querySelector('p').textContent=left?this.dataset.remaining.replace('[amount]',amount):this.dataset.complete;const bar=this.querySelector('progress');const target=Math.min(100,total/3000);cancelAnimationFrame(this.frame);if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){bar.value=target;return;}const start=bar.value;const started=performance.now();const tick=now=>{const fraction=Math.min(1,(now-started)/450);bar.value=start+(target-start)*(1-Math.pow(1-fraction,3));if(fraction<1)this.frame=requestAnimationFrame(tick);};this.frame=requestAnimationFrame(tick);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buy4tech-delivery-timeline"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('b4t-delivery-timeline')){
customElements.define('b4t-delivery-timeline',class extends HTMLElement{
connectedCallback(){this.updateDates();this.timer=setInterval(()=>this.updateDates(),60000);}
disconnectedCallback(){clearInterval(this.timer);}
updateDates(){
const parts=new Intl.DateTimeFormat('en-US',{timeZone:'Asia/Karachi',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date());
const value=t=>Number(parts.find(p=>p.type===t).value);
const base=Date.UTC(value('year'),value('month')-1,value('day'));
const format=offset=>{const date=new Date(base+offset*86400000);const day=date.getUTCDate();const mod=day%100;const suffix=mod>=11&&mod<=13?'th':({1:'st',2:'nd',3:'rd'}[day%10]||'th');return day+suffix+' '+new Intl.DateTimeFormat('en-US',{month:'short',timeZone:'UTC'}).format(date);};
const dates=[format(0),format(1)+' – '+format(2),format(3)+' – '+format(4)];
this.querySelectorAll('[data-delivery-step]').forEach(e=>e.textContent=dates[Number(e.dataset.deliveryStep)]);
}
});
}
  } catch(e) { console.error(e); }
})();

})();
